import { api } from '$app/api';

export const getGarageCoverage = (garageId) =>
  api.get(`/zones/areas?ownerId=${garageId}&getAllAreas=true`).then(({ data }) => data[0]);

export function getGarageZoneShapes() {
  return api.get('/zones/areas/all').then(res => res.data);
}

export const createGarageCoverage = data => api.post(`/zones/areas`, data);
